export default {
  title: "Ajustes",
  languages: {
    en: "Inglés",
    es: "Español",
  },
  mode: {
    title: "Modo",
    light: "Claro",
    dark: "Oscuro",
  },
}
